export default "__VITE_ASSET__YfztB2k6__"